/**
 * Recuerden que los tipos de filtros hay que centralizarlos de momento
 * en como funcionan por lo que hay que revisar como es el funcionamiento
 * en si, con esto me refiero a que la cantidad que deja seleccionar se 
 * controla desde el tablero los filtros solo permiten visualizar esa
 * información por lo cual creo conveniente renombrar los filtros en este mismo enum
 * pero ahora tratare de describir lo que hace cada uno para que vallamos migrando a estos
 */

export enum FiltersM{

  /**
   * Filtro encargado de mostrar los elementos como arbol donde se puede hacer
   * selección solo a partir del segundo nivel, por ejemplo los que normalmente
   * para periodos.
   * 
   * Estructura:
   * 
   * anio,
   * visible,
   * series : {
   *  anio,
   *  mes,
   *  check,
   *  visible,
   * }
   */
  TREE = 'tree',

  /**
   * Filtro encargado de mostrar los elementos como arbol donde se puede hacer
   * Selección desde cualquier nivel o de los niveles que lleven select
   * 
   * Estructura:
   *  
   * name,
   * check?,
   * series : {
   *  name,
   *  check?,
   *  series: {
   *    ...
   *  }
   * }
   */
  PERIOD = 'period',

  /**
   * Filtro encargado de mostrar los elementos en solo una lista ejemplo los años, meses cuando van por separado 
   *  
   * Estructura:
   * 
   * name,
   * check
   * 
   */
  COMMON = 'common',

  /**
   * Filtro encargado de mostrar la lista y el boton de consolidado
   * 
   * Estructura:
   * 
   * name,
   * check
   */
  CONSOLIDADO = 'consolidado',


  /** -------------------------------------------------------------------- */
  
  /**
   * Ejemplo:
   * 
   * {} ene
   * {} feb
   * {|} mar 
   */
  MOUNTH = 'mounth',
  
  /**
   * Ejemplo:
   * 
   * {} 2023
   * {} 2024
   * {|} 2025 
   */
  YEAR = 'year',
  
  /**
   * Ejemplo:
   * 
   * {} perspectiva 1
   * {} perspectiva 2
   * {|} perspectiva 3 
   */
  PERSPECTIVES = 'perspectives',
  
  /**
   * Ejemplo:
   * 
   * {} Consolidado
   *  -------------
   * {} Sucursal 1
   * {} Sucursal 2
   * {|} Sucursal 3
   */
  SUCURSALES = 'branches',
  
  /**
   * 
   */
  ESCENARIOS = 'Escenarios',
  /**
   * 
   */
  BUSQUEDA = 'BUSQUEDA',
  /**
   * 
   */
  INDICADORES = "INDICADORES",
  /**
   * 
   */
}
export enum typesApex {
  BAR = 'bar',
  LINE = 'line',
  PIE = 'pie',
  DONUT = 'donut',
  HEATMAP = 'treemap',
  TABLE = 'table',
  AREA = 'area',
  COMBO = 'combo',
  COMBO2 = 'combo2',
  FUNNEL = 'funnel',
  STACKED = 'stacked',
  BARHORIZONTAL = 'barHorizontal',
  STACKEDHORIZONTAL = 'stackedHorizontal',
  RADAR = 'radar',
  WATERFALL = 'waterfall',
  BUBBLE = 'bubble',
}
